/**
 * Roles del sistema, mapeados desde los grupos de Alfresco actuales.
 *
 *   GROUP_CJIDF        → 'gestor'   (operar préstamos y consultas)
 *   GROUP_CJIDFCREA    → 'creador'  (crear expedientes)
 *   GROUP_cjidfadmin   → 'admin'    (administración total)
 */
export const ROLES = ['gestor', 'creador', 'admin'];
/** Administradores del módulo. Por decisión del negocio, SOLO gdocumental. */
export const ADMINS_MODULO = [
    'gdocumental@centrojuridicointernacional.com',
];
/** ¿El correo corresponde a un administrador del módulo? (solo la lista; no el claim del portal) */
export function esAdminModulo(email, _claimAdmin) {
    return !!email && ADMINS_MODULO.includes(email.toLowerCase());
}
/** Correspondencia grupo Alfresco → rol nuevo (útil para migrar usuarios). */
export const GRUPO_ALFRESCO_A_ROL = {
    GROUP_CJIDF: 'gestor',
    GROUP_CJIDFCREA: 'creador',
    GROUP_cjidfadmin: 'admin',
};
/** ¿El conjunto de roles otorga permiso de administración? */
export function esAdmin(roles) {
    return roles.includes('admin');
}
/** Un gestor (o admin) puede operar préstamos. */
export function puedeGestionar(roles) {
    return roles.includes('gestor') || esAdmin(roles);
}
/** Un creador (o admin) puede crear expedientes. */
export function puedeCrear(roles) {
    return roles.includes('creador') || esAdmin(roles);
}
//# sourceMappingURL=roles.js.map